export type Pt = { x: number; y: number };

export const resampleAtEqualArcLength = (points: Pt[], count: number): Pt[] => {
	if (points.length <= 2) return points;

	const lengths: number[] = [0];
	for (let i = 1; i < points.length; i++) {
		lengths.push(lengths[i - 1] + Math.hypot(points[i].x - points[i - 1].x, points[i].y - points[i - 1].y));
	}
	const totalLen = lengths[lengths.length - 1];
	if (totalLen === 0) return points;

	const step = totalLen / (count - 1);
	const result: Pt[] = [points[0]];
	let segIdx = 0;

	for (let i = 1; i < count - 1; i++) {
		const target = i * step;
		while (segIdx < lengths.length - 2 && lengths[segIdx + 1] < target) segIdx++;
		const segLen = lengths[segIdx + 1] - lengths[segIdx];
		const t = segLen === 0 ? 0 : (target - lengths[segIdx]) / segLen;
		result.push({
			x: points[segIdx].x + t * (points[segIdx + 1].x - points[segIdx].x),
			y: points[segIdx].y + t * (points[segIdx + 1].y - points[segIdx].y),
		});
	}

	result.push(points[points.length - 1]);
	return result;
};

export const toPts = (flat: number[]): Pt[] => {
	const pts: Pt[] = [];
	for (let i = 0; i + 1 < flat.length; i += 2) pts.push({ x: flat[i], y: flat[i + 1] });
	return pts;
};

export const toFlat = (pts: Pt[]): number[] => {
	const flat: number[] = [];
	for (const p of pts) flat.push(p.x, p.y);
	return flat;
};

export const closedArcLength = (pts: Pt[]): number => {
	let len = 0;
	for (let i = 1; i < pts.length; i++) len += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y);
	len += Math.hypot(pts[0].x - pts[pts.length - 1].x, pts[0].y - pts[pts.length - 1].y);
	return len;
};
